import { supabase } from './supabase';
export interface ProfessionalCredential {
  id: string; profile_id: string; kind: 'license' | 'insurance'; title: string;
  issuer: string | null; credential_number: string | null; expires_on: string | null;
  renewal_url: string | null; notes: string | null; storage_path: string | null;
  archived_at: string | null; created_at?: string; updated_at?: string;
}
export const credentialFields = ['kind','title','issuer','credential_number','expires_on','renewal_url','notes'] as const;
export function expirationLabel(date: string | null, today = new Date()): string {
  if (!date) return 'Expiration not provided';
  const days = Math.ceil((new Date(`${date}T23:59:59`).getTime()-today.getTime())/86400000);
  return days < 0 ? 'Expired — review needed' : days <= 30 ? `Renewal due within ${days} days` : `Expires ${date}`;
}
export async function saveCredential(input: ProfessionalCredential, file?: File | null): Promise<void> {
  if (!supabase) throw new Error('Sign in to save business credentials.');
  if (!input.title.trim()) throw new Error('A credential title is required.');
  if (input.renewal_url && !/^https:\/\/[^\s]+$/i.test(input.renewal_url)) throw new Error('Use a complete https renewal-portal URL.');
  const {data,error:authError}=await supabase.auth.getUser();
  if (authError || !data.user) throw new Error('Sign in before saving credentials.');
  if(input.profile_id !== data.user.id) throw new Error('Only your own credentials can be edited.');
  let uploadedPath: string | null = null;
  if(file) {
    if(file.size>20*1024*1024 || !['application/pdf','image/jpeg','image/png'].includes(file.type)) throw new Error('Choose a PDF, JPEG or PNG file up to 20 MB.');
    const extension = file.type === 'application/pdf' ? 'pdf' : file.type === 'image/png' ? 'png' : 'jpg';
    uploadedPath=`${data.user.id}/${input.id}/${crypto.randomUUID()}.${extension}`;
    const {error}=await supabase.storage.from('professional-credentials').upload(uploadedPath,file,{contentType:file.type,upsert:false});
    if(error) throw error;
  }
  const {error}=await supabase.rpc('save_my_professional_credential',{
    credential_id:input.id,
    credential_kind:input.kind,
    credential_title:input.title,
    credential_issuer:input.issuer || null,
    credential_number:input.credential_number || null,
    credential_expires_on:input.expires_on || null,
    credential_renewal_url:input.renewal_url || null,
    credential_notes:input.notes || null,
    credential_storage_path:uploadedPath ?? input.storage_path
  });
  if(error) {
    if(uploadedPath) await supabase.storage.from('professional-credentials').remove([uploadedPath]);
    throw error;
  }
}
